import React from "react";

import { useTranslation } from "react-i18next";

import { usePatientIdFromURL } from "@/hooks/usePatientIdFromURL.ts";
import { Queries } from "@/queries/Queries.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";

export const OnboardingManagement: React.FC = () => {
  const patientId = usePatientIdFromURL();
  const { t } = useTranslation();

  const skipOnboarding = Queries.qa.useSkipOnboarding();
  return (
    <Card>
      <CardHeader title={t("QaTools.onboarding")} />
      <CardContent>
        <Button
          data-action="qa.onboarding.skip"
          variant="contained"
          onClick={() => skipOnboarding.mutate({ patientId })}
        >
          {t("QaTools.skipOnboarding")}
        </Button>
      </CardContent>
    </Card>
  );
};
